import React, { useRef, useState } from 'react'
import {
  Button,
  Card,
  Steps
} from "antd";
import './index.less'
import ActivityInfo from './activity-info'
import AddGoods from './add-goods'
import Success from './success'

import {COMMON_ROUTER} from "../../../constants";

const {Step} = Steps;
const Progress2 = ({location, history}) => {
  const [current, setCurrent] = useState(0)
  const [activityId, setActivityId] = useState(null)
  const infoRef = useRef()

  console.log('EditActivity' + location.state.activityId)
  const steps = [
    {
      title: '活动信息',
      content: <ActivityInfo activityId={location.state.activityId} templateId={location.state.templateId} activityInfoRef={infoRef}/>,
    },
    {
      title: '添加商品',
      content: <AddGoods go={setCurrent} activityId={activityId} templateId={location.state.templateId}/>,
    },
    {
      title: '创建成功',
      content: <Success history={history}/>,
    },
  ]

  const next = () => {
    console.log(infoRef.current)
    infoRef.current.onSubmit(current, setCurrent, setActivityId)
    /* if (res) {
       let currents = current + 1;
       setCurrent(currents)
     } else {

     }*/
  }

  const prev = () => {
    history.push(COMMON_ROUTER + '/activitys')
  }

  return (
    <Card style={{width: '80%', margin: "0 auto"}}>
      <Steps current={current}>
        {steps.map(item => (
          <Step key={item.title} title={item.title}/>
        ))}
      </Steps>
      <div className="steps-content">{steps[current].content}</div>
      <div className="steps-action">
        {current < steps.length - 2 && (
          <Button type="primary" htmlType="submit" onClick={next}>
            下一步
          </Button>
        )}

        {current > 0 && current < 2 && (
          <Button style={{margin: '0 8px'}} onClick={() => prev()}>
            取消
          </Button>
        )}
      </div>
    </Card>
  )
}

export default (props) => {
  console.log('---------')
  console.log(props)
  return <div>
    <Progress2 location={props.location} history={props.history}/>
  </div>
}



// WEBPACK FOOTER //
// ./src/pages/activitys/edit-activity/index.js